import { commonUtils } from '@/helpers/commonUtils'
import PdfPage, { PageHeader, useMarkdownFontSize } from '../PdfPage/PdfPage'
import styles from './PdfPage10.module.less'
import MarkdownRenderer from '@/components/MarkdownRenderer/MarkdownRenderer'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage10({ project, onRendered, no }: Props) {
  const BOX_MAX_HEIGHT = 690
  const summaryRef = useRef<HTMLDivElement>(null)
  const { fontsize, end } = useMarkdownFontSize(summaryRef, BOX_MAX_HEIGHT)

  const { t } = useTranslation()
  useEffect(() => {
    if (end) {
      onRendered(1)
    }
  }, [end])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-7/PDF-bg.jpg')} no={no}>
      <div className={styles.pdfPage10}>
        <PageHeader
          project={project}
          text={'02.' + t('dashboard.projectDetailPage.primaryAnalysis')}
        />

        <p className={styles.title}>
          <img
            className={styles.icon}
            src={commonUtils.getImagePath('PDFDownload/pdf-page-10/page10-icon.png')}
          />
          <span>{t('dashboard.projectDetailPage.storyboardView.suggestions')}</span>
        </p>

        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.summary} ref={summaryRef}>
              <MarkdownRenderer
                style={{ fontSize: fontsize }}
                markdownText={project.globalMetrics.reason.suggestions || ''}
              />
            </div>
          </div>

          <div className={styles.right}>
            <img
              className={styles.img}
              src={commonUtils.getImagePath('PDFDownload/pdf-page-10/right-img.jpg')}
            />
          </div>
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPage10
